<template>
      <div :class="['modal-container',{ active: isActive }]">
      <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
      <div class="card head-card news oDatosCard">
        <div class="title-card">
          <h4>Resumen de Datos</h4>
          <button class="touchpad" @click="cerrar()">x</button>
        </div>
        <div class="card-content">
          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark">Origen de Datos</p>
            </div>
            <div class="card">
              <p class="paragraph dark">{{ pdata.origenDatos }}</p>
            </div>
            
          </div>
          <div class="item" v-if="channel">
            <div class="card secondary">
              <p class="paragraph dark">Canal</p>
            </div>
            <div class="card">
              <p class="paragraph dark">{{ channel }}</p>
            </div>
            
          </div>

          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark">Ubicación</p>
            </div>
            <div class="card">
              <p class="paragraph dark">{{ pdata.ubicacion }}</p>
            </div>
          </div>
          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark">Fecha y Horario</p>
            </div>
            <div class="card">
              <p class="paragraph dark" v-if="pdata.dias" >Ultimos: {{ pdata.dias}} dias</p>
              <p class="paragraph dark">Inicio: {{ pdata.finicial}}</p>
              <p class="paragraph dark">Final: {{ pdata.ffinal}}</p>
              <p class="paragraph dark">Horario: {{ pdata.hinicial }} - {{ pdata.hfinal }}</p>
            </div>
          </div>
          <button v-if="from=='gauge'" class="button alternative fluid" @click="() => {verNotas()}">Ver notas</button>
        </div>
      </div>
    </div>
</template>

<script>
import moment from "moment-timezone";


export default {
    props: ["isActive", "query", "from", "gkey","channel"],
    data(){
      return{
       pdata: {
        origenDatos: "",
        ubicacion: "Global",
        finicial: "",
        ffinal: "",
        hinicial: "",
        hfinal: "",
        fi: []
      }
      };
    },
    beforeMount(){
      this.setDataSource({gaugeQuery : this.query});
    },
    methods:{
      getFechas(obj){
        var dias = obj.dias; //dias atrás
        var fecha = moment();
        var fechaFin = moment.tz(fecha,'America/Mexico_City').format('DD-MM-YYYY');
        var fecha2 = fecha.subtract(dias-1, 'days'); 
        var fechaInicio = moment.tz(fecha2,'America/Mexico_City').format('DD-MM-YYYY'); 
        return { fechaInicio:fechaInicio,fechaFin:fechaFin}
      },
      getDate(date) {
        var fecha = moment(date,'YYYY-MM-DD').format('DD-MM-YYYY');
        return fecha;
      },
      setDataSource(cData) {
        var dias = parseInt(cData.gaugeQuery.dias);
        
        this.pdata.hinicial = cData.gaugeQuery.hora ? cData.gaugeQuery.hora.ini : '00:00';
        this.pdata.hfinal = cData.gaugeQuery.hora ? cData.gaugeQuery.hora.fin:'23:59' ;
        
        if(!isNaN(dias)){
          this.pdata.dias = dias;
          var fechas = this.getFechas({dias:dias,horas:{horaInicio: this.pdata.hinicial,horaFin: this.pdata.hfinal}});
          this.pdata.ffinal = fechas.fechaFin;
          this.pdata.finicial = fechas.fechaInicio;
        }else{
          this.pdata.finicial = this.getDate( cData.gaugeQuery.fecha.ini );
          this.pdata.ffinal = this.getDate(cData.gaugeQuery.fecha.fin );
        }
        this.pdata.ubicacion = cData.gaugeQuery.ubicacion;
        this.pdata.fi = cData.gaugeQuery.fi;
        
        var arr = [];
        if (cData.gaugeQuery.fi.FB) {
          arr.push("Facebook")
        }
        if (cData.gaugeQuery.fi.I) {
          arr.push("Instagram")
        }
        if (cData.gaugeQuery.fi.TW) {
          arr.push("Twitter")
        }
        if (cData.gaugeQuery.fi.PD) {
          arr.push("Portales digitales")
        }
        if (cData.gaugeQuery.fi.R) {
          arr.push("Radio")
        }
        if (cData.gaugeQuery.fi.T) {
          arr.push("Televisión")
        }
        if (cData.gaugeQuery.fi.Y) {
          arr.push("Youtube")
        }
        this.pdata.origenDatos = arr.toString();
      },
      cerrar(){
        this.$emit('cerrar');
      },
      verNotas(){
        console.log('ver notas origne')
        this.$emit('verNotas');
      }
    }
}
</script>